<template>
  <div class="warper-No">
    <!-- 未完善 -->
    <van-search
      v-model="valueInfo"
      show-action
      placeholder="请输入搜索关键词"
      @search="onSearch"
    >
      <template #label>
        <select v-model="types">
          <option :value="1">车牌号</option>
          <option :value="2">车架号</option>
        </select>
      </template>
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="box"
          v-for="(item, index) in list"
          :key="index"
          @click="openChaneg(item)"
        >
          <van-field label="车牌号" :value="item.carNumberPlate" readonly />
          <van-field label="车架号" :value="item.vin" readonly />
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="show" position="bottom" :style="{ height: '100%' }">
      <dataInfoDetail ref="DetailRef" @closePage="closePage" v-if="show" />
    </van-popup>
  </div>
</template>

<script>
import { zhbList } from "@/api/api";
import { Toast } from "vant";
import dataInfoDetail from "./dataInfoDetail.vue";
export default {
  props: ["type"],
  components: {
    dataInfoDetail,
  },
  data() {
    return {
      list: [], //列表
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      show: false,
      statusId: 1,
      valueInfo: "",
      types: 1,
    };
  },
  mounted() {},
  methods: {
    onSearch() {
      this.list = [];
      this.page = 0;
      this.onLoad();
    },
    getId(i) {
      console.log("打印", this.from);

      this.list = [];
      this.page = 0;
      this.valueInfo = "";
      this.statusId = i == 0 ? 1 : 2;
      this.types = 1;

      // this.$forceUpdate()

      this.onLoad();
    },
    openChaneg(item) {
      this.show = true;
      this.$nextTick(() => {
        this.$refs.DetailRef.getData(item, this.statusId);
      });
    },
    closePage() {
      this.show = false;
      this.onRefresh();
    },
    //获取资料
    onLoad() {
      let this_ = this;
      let toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中...",
      });
      setTimeout(async () => {
        let page = this_.page + 1;
        this_.page = page;
        const { data } = await zhbList({
          status: this.statusId,
          page,
          type: this.types,
          value: this.valueInfo,
        }).then((res) => res);
        toast.clear();
        if (data.data.length == 0) {
          //this_.list = []
          this_.finished = true;
          this_.refreshing = false;
        } else {
          let arr = data.data.data;
          arr.forEach((element) => {
            this_.list.push(element);
          });
          if (this_.list.length >= data.data.total) {
            this_.finished = true;
            this_.refreshing = false;
          } else {
            this_.finished = false;
            // this_.refreshing = false
          }
        }
        console.log(this_.list);
        this_.loading = false;
      }, 1000);
    },
    onRefresh() {
      this.page = 0;
      // 清空列表数据
      this.list = [];
      this.finished = false;
      this.refreshing = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>

<style lang="scss" scoped>
.warper-No {
  padding: 10px;
  height: calc(100vh - 2.3rem);
  background-color: #eee;
  overflow: scroll;
  .box {
    margin: 5px 0;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>
